import BaseApiRequest from "./BaseApiRequest";
import { APPLICANT_CREATE_SELF_URL } from "../ApiUrls";
import { METHOD } from "../Constants";
import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class ApplicantCreateSelf extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  body = [];

  url = APPLICANT_CREATE_SELF_URL;

  constructor(reqData) {
    super();
    this.body = reqData;
    console.log(reqData);
    console.log(this.body);
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
